// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tiptap-vuetify-editor__content {\n  height: 200px;\n}\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n.table-cell {\n  max-height: 100px;\n  overflow: scroll;\n}\n.v-data-table__mobile-row__cell .table-cell {\n  max-height: 175px;\n}\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n", ""]);
// Exports
module.exports = exports;
